export default __webpack_public_path__ + "static/media/gallery-7.63dcae22.jpg";